import { createSlice } from "@reduxjs/toolkit";

const skillPathPageSlice = createSlice({
  name: "skillPathPage",
  initialState: {   
    skillPathId: null,
    domainName: null,
    domainId: null,
    domainTypeId: null,
    domainStatus: null,
  },
  reducers: {
    resetState(state, action) {
      state.saveUserProfileProgress = false;
    },
    setState(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const skillPathPageActions = skillPathPageSlice.actions;

export default skillPathPageSlice.reducer;